"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorSignatures = void 0;
exports.errorSignatures = {
    "0xdb36a8f0": "AddressAlreadyExists",
    "0xf0f16622": "BalanceExceed",
    "0x3d1350e0": "DepositNotComplete",
    "0xf5390b24": "DiamondAlreadyInitialised",
    "0x03dee4c5": "ERC1155InsufficientBalance",
    "0x3e31884e": "ERC1155InvalidApprover",
    "0x5b059991": "ERC1155InvalidArrayLength",
    "0xced3e100": "ERC1155InvalidOperator",
    "0x57f447ce": "ERC1155InvalidReceiver",
    "0x01a83514": "ERC1155InvalidSender",
    "0xe237d922": "ERC1155MissingApprovalForAll",
    "0xfb8f41b2": "ERC20InsufficientAllowance",
    "0xe450d38c": "ERC20InsufficientBalance",
    "0xe602df05": "ERC20InvalidApprover",
    "0xec442f05": "ERC20InvalidReceiver",
    "0x96c6fd1e": "ERC20InvalidSender",
    "0x94280d62": "ERC20InvalidSpender",
    "0x64283d7b": "ERC721IncorrectOwner",
    "0x177e802f": "ERC721InsufficientApproval",
    "0xa9fbf51f": "ERC721InvalidApprover",
    "0x5b08ba18": "ERC721InvalidOperator",
    "0x89c62b64": "ERC721InvalidOwner",
    "0x64a0ae92": "ERC721InvalidReceiver",
    "0x73c6ac6e": "ERC721InvalidSender",
    "0x7e273289": "ERC721NonexistentToken",
    "0xfcce859d": "ETHInsufficientBalance",
    "0xc847f819": "ETHInvalidReceiver",
    "0xdf4cc36d": "ExpiredSignature",
    "0xa9ad62f8": "FunctionDoesNotExist",
    "0xb3511d16": "GenesNotOwnerNorApproved",
    "0x897169d0": "GenesPregnancyCountLimitExceed",
    "0x546f6975": "GenesPregnancyTimeLimitExceed",
    "0xf461d719": "LotteryBalanceExceed",
    "0x98ddb3c4": "LotteryInsufficientBalance",
    "0x0594f5ba": "LotteryNoPrize",
    "0x86c76446": "LotteryNotOwnerNorApproved",
    "0x767b077b": "LotteryNumbersNotRevealed",
    "0xebf531d7": "LotteryPrizeNotEligible",
    "0xb20d16b7": "LotteryRootRoundNotAllowed",
    "0xca4b8f09": "LotteryRoundNotActive",
    "0x18d326b1": "LotteryRoundNotComplete",
    "0x8a35bd73": "LotteryTicketExpired",
    "0xddf9ff20": "LotteryTicketLimitExceed",
    "0xd1ab681d": "LotteryTicketPrizeClaimed",
    "0x008028c4": "LotteryWrongRound",
    "0x000d796c": "LotteryWrongTicketAsset",
    "0xa735d4c6": "LotteryWrongToken",
    "0x3301fd38": "LotteryZeroBalance",
    "0xdadda903": "MergeDifferentContracts",
    "0xa178a447": "MergeDifferentTemplate",
    "0xcd7ee2ee": "MethodNotSupported",
    "0xc5801ff4": "MissingRoot",
    "0x93a0236d": "NoContent",
    "0x0483ac36": "NoItems",
    "0xc149905d": "NoPrice",
    "0x6e992686": "NoReward",
    "0x351c880f": "NotAnOwner",
    "0xc476e34b": "NotOwnerNorApproved",
    "0x6dbbc202": "PonziBalanceExceed",
    "0xb5bf3f24": "PonziDepositNotComplete",
    "0x0dd7798d": "PonziNotAnOwner",
    "0x03b25a4d": "PonziRuleNotActive",
    "0x9f96ef4f": "PonziRuleNotExist",
    "0xc5910d80": "PonziStakeAlreadyWithdrawn",
    "0x1a10e951": "PonziStakeLimitExceed",
    "0x8ff3bb3c": "PonziStakeNotExist",
    "0x01db5a94": "PonziWrongTemplate",
    "0xa159199c": "PonziZeroBalance",
    "0xe9bd70e2": "PredictionAlreadyResolved",
    "0x4397222f": "PredictionBetAlreadyPlaced",
    "0x18aee06d": "PredictionBetAmountTooLow",
    "0x187ff6c6": "PredictionBetNotFound",
    "0x5457b749": "PredictionCannotClaimBeforeResolution",
    "0xee515eaa": "PredictionEnded",
    "0xcbd819ac": "PredictionInvalidOutcome",
    "0x8d570457": "PredictionNoTreasuryAssets",
    "0xf7df1016": "PredictionNotEligibleForClaim",
    "0xb648cd78": "PredictionNotFound",
    "0x15488d57": "PredictionNotStarted",
    "0xecede0d9": "PredictionRewardAlreadyClaimed",
    "0x28b4338e": "PredictionTreasuryFeeTooHigh",
    "0x6e113271": "PredictionWrongToken",
    "0x6b957cf2": "PregnancyFrequencyExceeded",
    "0xd74b8bbc": "PregnancyThresholdExceeded",
    "0xf4819eef": "PrizeNotEligible",
    "0xd0de08d7": "ProtectedAttribute",
    "0x72a8b679": "RaffleNotOwnerNorApproved",
    "0x634f06a2": "RafflePrizeNotEligible",
    "0x6fc0251d": "RaffleRoundNotActive",
    "0x239d7389": "RaffleRoundNotComplete",
    "0xec2c266c": "RaffleTicketExpired",
    "0x932534c7": "RaffleTicketLimitExceed",
    "0x3eefbf9a": "RaffleWrongRound",
    "0x2a0ab845": "RaffleWrongToken",
    "0x10cb6e1c": "RaffleZeroBalance",
    "0xcf95f450": "RentableNoItems",
    "0xb3f8c0dc": "RewardAlreadyClaimed",
    "0xb466ddbf": "RootAlreadySet",
    "0x3df07da5": "RoundNotActive",
    "0x159c98a0": "RoundNotComplete",
    "0x822e0207": "RuleNotActive",
    "0x97a5f3a5": "RuleNotExist",
    "0x255a6a43": "SignerMissingRole",
    "0x64141f34": "StakeAlreadyWithdrawn",
    "0x67469368": "StakeLimitExceed",
    "0x7961d074": "StakeNotExist",
    "0xc5db208a": "StakingBalanceExceed",
    "0x24a75eea": "StakingDepositNotComplete",
    "0x12a16966": "StakingNotAnOwner",
    "0x598aad18": "StakingRuleNotActive",
    "0x837c638c": "StakingRuleNotExist",
    "0xd5b96da1": "StakingStakeAlreadyWithdrawn",
    "0xb59f022f": "StakingStakeLimitExceed",
    "0xd12092a0": "StakingStakeNotExist",
    "0x1c1a3884": "StakingWrongTemplate",
    "0xa450c89b": "StakingZeroBalance",
    "0x5c201a4d": "TemplateZero",
    "0x40d35447": "TicketExpired",
    "0xefed8ba9": "TicketLimitExceed",
    "0xd78b7d54": "UnsupportedTokenType",
    "0x4ad96289": "WaitListAddressAlreadyExists",
    "0xb05b1b1d": "WaitListMissingRoot",
    "0x4fcc7d10": "WaitListNoReward",
    "0x8a0f93cf": "WaitListRewardAlreadyClaimed",
    "0x74ccfad9": "WaitListRootAlreadySet",
    "0x2a00e5c6": "WrongArrayLength",
    "0x76699990": "WrongRole",
    "0xc3fa7054": "WrongRound",
    "0xaa2f01ea": "WrongTemplate",
    "0xa0f3feea": "WrongToken",
    "0x669567ea": "ZeroBalance"
};
//# sourceMappingURL=error-signatures.js.map